import { NomadDB } from '~/db/NomadDB.js';
import type { ProgressionSchema } from '@/types/schema';

export const getProgressionsService = (db: NomadDB) => {
  const count = async (): Promise<number> => {
    return await db.progressions.count();
  };

  const getByTypeContentIdAndMemberId = async (
    type: string,
    contentId: string,
    memberId: string
  ): Promise<ProgressionSchema> => {
    const progression = await db.progressions.get([type, contentId, memberId]);
    return progression;
  };

  const put = async (progression: ProgressionSchema): Promise<any> => {
    return await db.progressions.put(progression);
  };

  const update = async (
    key: any,
    progression: ProgressionSchema
  ): Promise<any> => {
    return await db.progressions.update(key, progression);
  };

  const findByTypeIdsAndMemberId = async (
    type: string,
    ids: string[],
    memberId: string
  ): Promise<ProgressionSchema[]> => {
    const params = ids.map((id) => [type, id, memberId]);
    return await db.progressions
      .where(['type+contentId+member'])
      .anyOf(params)
      .toArray();
  };

  const findById = async (id: string): Promise<ProgressionSchema[]> => {
    return await db.progressions.where({ contentId: id }).toArray();
  };

  const findTrialContents = async (): Promise<ProgressionSchema[]> => {
    return await db.progressions
      .where('type')
      .startsWith('trialContent_')
      .toArray();
  };

  const findByTypes = async (types: string[]): Promise<ProgressionSchema[]> => {
    return await db.progressions.where('type').anyOf(types).toArray();
  };

  return {
    count,
    put,
    update,
    getByTypeContentIdAndMemberId,
    findByTypeIdsAndMemberId,
    findTrialContents,
    findById,
    findByTypes,
  };
};
